import {
  ShowThisField,
  LabelInput,
  LabelTextArea,
  PageBreakAfterToggle,
  DecimalPlaces,
} from 'apps/builder/components/settings/modal/more/shared'

export const StandardWebFormMoreSettings = ({
  decimalPlace = false,
  ...entry
}) => {
  const entryPDF = {
    showThisFieldType: 'pdf',
    ...entry,
  }

  const entryWeb = {
    showThisFieldType: 'web',
    ...entry,
  }

  const entryExport = {
    labelType: 'export',
    ...entry,
  }

  const entryReceipt = {
    labelType: 'receipt',
    ...entry,
  }

  return (
    <>
      {decimalPlace && (
        <div className="settings--row">
          <div className="show-this-field-wrapper">
            <DecimalPlaces {...entry} />
          </div>
        </div>
      )}
      <div className="settings--row">
        <div className="show-this-field-wrapper">
          <label className="settings--label">Visibility</label>
          <ShowThisField {...entryPDF} />
          <ShowThisField {...entryWeb} />
        </div>
        <div className="toggles-group">
          <div className="toggle-wrapper">
            <PageBreakAfterToggle {...entry} />
          </div>
        </div>
      </div>
      <label className="settings--label">Labels</label>
      <div className="checkbox-labels-wrapper">
        <LabelInput {...entryExport} />
        <LabelInput {...entryReceipt} />
      </div>
      <LabelTextArea {...entry} />
    </>
  )
}
